import { EngineContext, getLayout as getGameLayout } from '../../../layouts/GameLayout'
import { fetchAsset } from '../../../hooks/nft'
import useExhibition from '../../../hooks/useExhibition'
import AssetPanel from '../../../components/asset/AssetPanel'
import Header from '../../../components/Header'
import { connect } from 'react-redux'
import { useContext, useEffect, useRef, useState } from 'react'
import { openPopout } from '../../../redux/site'
import Button from '../../../components/Button'
import Link from 'next/link'
import Image from 'next/image'
import Onboarding from '../../../components/onboarding/Onboarding'
import Authenticate from '../../../components/auth/Authenticate'
import { useRouter } from 'next/router'
import Loader from '../../../components/Loader'
import useSWR from 'swr'
import ASSETS from '../../../data/alternate-dimensions'
import Head from 'next/head'


const ExhibitionMetadata = _ => {
  return <>
    <title>Alternate Dimensions - by Margaret Garrett</title>
    <meta name="description" content='Films and paintings celebrating the body in motion by multidisciplinary artist Margaret Garrett'/>

    {/* Twitter */}
    <meta name="twitter:card" content="summary" key="twcard" />
    <meta name="twitter:creator" content='@cryptdotart' key="twhandle" />

    {/* Open Graph */}
    <meta property="og:url" content={process.env.NEXT_PUBLIC_SITE_URL + 'exhibitions/alternate-dimensions'} key="ogurl" />
    <meta property="og:image" content='https://www.crypt.art/images/exhibitions/still_alternatedimensions.png' key="ogimage" />
    <meta property="og:site_name" content='The Crypt' key="ogsitename" />
    <meta property="og:title" content='Alternate Dimensions - by Margaret Garrett' key="ogtitle" />
    <meta property="og:description" content='Films and paintings celebrating the body in motion by multidisciplinary artist Margaret Garrett' key="ogdesc" />
  </>
}

const getAsset = assetId => fetchAsset(ASSETS[assetId])

const AlternateDimensions = props => {
  const { site, asset } = props
  const [isExploring, setRequestExplore, progress] = useExhibition()
  const { query } = useRouter()
  const isAssetPath = !!(query.asset && query.asset.length > 0)

  return (
    <> 
      <ExhibitionMetadata />
      {!site.popoutState && !isExploring && !asset && (
        <div className='flex-grow p-6 md:p-4 select-none text-left pointer-events-auto'>
          <div className='space-y-4'>
            <h1 className='text-white font-display text-5xl md:text-6xl lg:text-8xl xl:text-9xl'>Alternate Dimensions</h1>
            <p className='hidden md:block max-w-prose text-white'>Films and paintings celebrating the body in motion by multidisciplinary artist Margaret Garrett</p>
          </div>
          <div className='flex space-x-8 pt-8 items-center w-full pointer-events-auto'>
            <Button className='' onClick={setRequestExplore}>
              View the collection
            </Button>
          </div>
        </div>
      )}
      {asset && (
        <AssetPanel asset={asset} />
      )}
    </>
  )
}



export const getStaticProps = async ({ params }) => {
  const props = { sceneName: 'alternate-dimensions', heroImage: '/images/exhibitions/still_alternatedimensions.png'  }
  if (!params.asset) return { props }

  const asset = await getAsset(params.asset[0])

  return {
    props: { 
      ...props, 
      asset,
      revalidate: 60
   }
  }
}

export const getStaticPaths = async _ => {

  const assetNames = Object.keys(ASSETS)

  const assetPaths = assetNames.map(assetName => ({ params: { asset: [assetName] } }))

  const paths = [{ params: { asset: [''] } }, ...assetPaths]
  return {
    paths,
    fallback: false
  }
}

const mapStateToProps = ({ site }, ownProps) => ({ ...ownProps, site })
const ConnectedAlternateDimensions = connect(mapStateToProps, null )(AlternateDimensions)

ConnectedAlternateDimensions.getLayout = getGameLayout
export default ConnectedAlternateDimensions
